module.exports = __webpack_public_path__ + "static/media/Internal-Jogging-Image.7ee287c7.jpg";